<template>
  <div>
    <div style="margin: 20px">
      温馨提示：系统将为您开放7日内时段预约，
      每日上午10:00自动更新，一次预约可选择不同日期，共计可以预约3个时间段。
      <div v-if="$store.state.nowRoom.key==='mensetu'">预约面试室之前必须在“我的预约”页面绑定手机号，以便遗失物品时工作人员联系</div>
      <div v-if="$store.state.nowRoom.key==='mensetu'">预约面试室时需要输入面试单位</div>
    </div>
    <span v-if="!$store.state.nowRoom.mensetu">
      <img src="@/assets/seats.jpg" alt="background" style=" margin:10px auto; width: 99%">
    </span>
    <span v-else>
      <img src="@/assets/mensetu.jpg" alt="background" style=" margin:10px auto; width: 99% ;border-radius: 10px">
    </span>


    <div v-for="item of periods">
      <el-popover

          placement="top"
          width="320"
          v-model="item.visible">
        <p>请选择<span v-if="$store.state.nowRoom.mensetu">面试室</span><span v-else>座位</span></p>
        <div style="text-align: right; margin: 0">
          <el-popover
              v-for="titem of item.tables"
              placement="top"
              width="320"
              v-model="titem.visible">
            <p>确定选择:{{ item.period + " " + parsePeriod(item.period) }} {{ titem.tableName }}号<span
                v-if="$store.state.nowRoom.mensetu">面试室</span><span v-else>座位</span> 吗?</p>
            <el-button size="mini" type="primary"
                       @click="titem.visible=false;doSelect(titem.tableName,item.period,item)">确定
            </el-button>
            <el-button size="mini" @click="titem.visible=false">取消</el-button>
            <el-button type="text" slot="reference" style="margin: 10px">{{ titem.tableName }}</el-button>
          </el-popover>
          <span style="margin: 5px;color: orange" v-if="item.tables.length===0">暂无<span
              v-if="$store.state.nowRoom.mensetu">面试室</span><span v-else>座位</span>可以选择</span>
          <el-button size="mini" type="text" @click="loadAvailTable(item)"
          >刷新<span v-if="$store.state.nowRoom.mensetu">面试室</span><span v-else>座位</span>
          </el-button>
          <el-button size="mini" type="text" @click="item.visible = false;"
          >取消
          </el-button>

        </div>
        <el-button slot="reference" @click="item.loading=true;loadAvailTable(item)"
                   :loading="item.loading" style="margin: 5px">{{ item.period + " " + parsePeriod(item.period) }}
        </el-button>
      </el-popover>

      <br>
    </div>
    <span style="margin: 5px;color: orange" v-if="periods.length===0">暂无时间段可选择</span>
    <span>
        <el-button @click="getAllOpenPeriods"
                   style="margin: 5px;display: inline">
          刷新
        </el-button>
    </span>

  </div>


</template>

<script>
import axios from '@/utils/request'
import {parsePeriod} from "@/utils/WeekParser";

export default {
  name: 'Home',
  data() {
    return {
      periods: [],
      nowCountDownIdx: 0,
      nowCountDownButton : {}
    }
  },
  methods: {
    parsePeriod(p) {
      return parsePeriod(p)
    },
    getAllOpenPeriods() {
      axios.post("/GetAllOpenPeriods", {roomKey: this.$store.state.nowRoom.key}).then(res => {
        console.log(res);
        let array = []
        for (let item of res.data.data) {
          array.push({
            tables: [],
            period: item,
            visible: false,
            loading: false
          })
        }
        this.periods = array
      })
    },
    loadAvailTable(item) {
      axios.post("/GetSpecifiedDateTableInfo", {
        date: item.period,
        roomKey: this.$store.state.nowRoom.key
      }).then(res => {
        item.loading = false
        let tableInfo = []
        for (let table of res.data.info) {
          tableInfo.push({
            tableName: table,
            visible: false
          })
        }
        item.tables = tableInfo
        console.log(res);
      })
    },
    doSelect(table, period, item) {
      if (this.$store.state.nowRoom.key === 'mensetu') {
        this.openWarningDialog(5, table, period, item)
        // this.openMensetuCompanyDialog(table, period, item)
        return
      }
      axios.post("/DoSelectSeat", {Period: period, Seat: table, roomKey: this.$store.state.nowRoom.key}).then(() => {
        this.loadAvailTable(item)
      })
    },
    openWarningDialog(targetSeconds, table, period, item) {

        let idx = Math.floor(Math.random() * 100000000)
        this.$confirm('预约面试室注意事项<br>' +
            '1、面试室仅供在校生参加网上面试使用，如需自习请预约咖啡厅。<br>' +
            '2、面试室开放时间7：50——20：50（如遇重大节假日开放时间另通知）。需要提前预约时间段，并填写个人信息及面试单位全称，<span style="font-weight: bold;color: red">如有虚假，给予警告一次，累计三次取消预约资格。</span><br>' +
            '3、预约后，如有特殊情况无需使用，请至少提前2小时取消预约，如出现爽约情况，给予警告一次，累计三次取消预约资格。<br>' +
            '4、保持面试室整洁，<span style="font-weight: bold;color: red">禁止携带食物、乱图乱画，抽烟，乱扔垃圾等不文明行为。</span><br>' +
            '5、使用结束后，请带齐个人全部物品，遗留物品如有遗失，后果自负。', '注意事项', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          confirmButtonClass: 'my-confirm' + idx
        }).then(() => {
          this.openMensetuCompanyDialog(table, period, item)
        }).catch(() => {
          clearInterval(this.nowCountDownIdx)
          this.nowCountDownButton.innerText = "确定"
          this.$message({
            type: 'info',
            message: '取消预约'
          });
        });


      setTimeout(() => {
        let button = document.getElementsByClassName("my-confirm" + idx)[0]
        this.nowCountDownButton = button
        console.log(document.getElementsByClassName("my-confirm" + idx));
        button.disabled = true
        let second = 1

        button.innerText = "确定(" + targetSeconds + "s）"


        let intervalIdx = setInterval(() => {
          let timeRemaining = targetSeconds - second;
          button.innerText = "确定(" + timeRemaining + "s）"
          if (timeRemaining === 0) {
            clearInterval(intervalIdx)
            button.disabled = false
            button.innerText = "确定"
          }
          second++
          console.log(second)
        }, 1000)
        this.nowCountDownIdx = intervalIdx
      }, 100)


    },
    openMensetuCompanyDialog(table, period, item) {
      this.$prompt('请输入面试单位(必须大于五个字符)', '单位名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
      }).then(({value}) => {
        if (value.trim() === "") {
          this.$notify({
            type: 'warning',
            message: '还未输入面试单位名称',
            duration: 2 * 1000,
            position: "bottom-right"
          })
        } else {
          axios.post("/DoSelectSeat", {
            Period: period, Seat: table, roomKey: this.$store.state.nowRoom.key,
            MensetuCompany: value.trim()
          }).then(() => {
            this.loadAvailTable(item)
          })
        }

      }).catch(() => {
        this.$notify({
          type: 'info',
          message: '取消选座',
          duration: 2 * 1000,
          position: "bottom-right"
        })
      });
    }

  },
  mounted() {

  },
  created() {
    this.getAllOpenPeriods()
  }

}
</script>

<style scoped>
img {
  margin: 0;
  padding: 0;
}


.card {
  width: 80%;
  text-align: center;
  margin: 10px auto;
  font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}


</style>
<style>
.el-message-box {
  width: 325px;
}
</style>